<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          &nbsp;&nbsp;
          <button class="btn btn-outline-info" title="Bulk Uploader" @click="showReportIndex = (showReportIndex == 'open') ? 'false' : 'open'">
            <span class="icon" :class="(showReportIndex == 'open') ? 'icon--left-arrow' : 'icon--right-arrow'"></span>
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4" v-if="showReportIndex == 'open'">
          <div class="card">
            <div class="card-bod">
              <div class="row p-3" style="display: flex; justify-content: end;">
                <div class="col-md-4">
                  <div class="form-group">
                    <select class="form-control" name="" id="" style="height: auto;" v-model="reportVersion">
                      <option class="">Version</option>
                      <option value="v1">V1</option>
                      <option value="v2">V2</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 reports-div">
                  <ul class="reports-outer">
                    <li class="report-list" :class="(slug == currentReportSlug) ? 'active' : null" 
                          v-on:click="selectReport(slug,component)"
                          v-for="{name, slug, component} in reportTypes" :key="name">
                          {{ name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="(showReportIndex == 'open') ? 'col-md-8' : 'col-md-12'">
          <!-- Dynamic component rendering -->
          <component :is="currentReport" 
              :tours="tours" 
              :suppliers="suppliers"
              :tour_managers="tour_managers"    
              :affiliates="affiliates"   
              :airlines="airlines" 
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import RoomingReportFields from "@/components/Reports/RoomingReportFields.vue";
import DayReportFields from "@/components/Reports/DayReportFields.vue";
import AgedDebtorField from "@/components/Reports/AgedDebtorField.vue";
import BondingReportFields from "@/components/Reports/BondingReportFields.vue";
import SalesReportFields from "@/components/Reports/SalesReportFields.vue";
import CustomerDetailReport from "@/components/Reports/CustomerDetailReport.vue";
import CustomerReportFields from "@/components/Reports/CustomerReportFields.vue";
import AffiliateReportFields from "@/components/Reports/AffiliateReportFields.vue";
import RevenueReportFields from "@/components/Reports/RevenueReportFields.vue";
import PaymentReportFields from "@/components/Reports/PaymentReportFields.vue";
import AddWordRevenueReportFields from "@/components/Reports/AddWordRevenueReportFields.vue";
import TourBookingAirlines from "@/components/Reports/TourBookingAirlines.vue";
import TourInstanceFlightBudgets from "@/components/Reports/TourInstanceFlightBudgets.vue";

export default {
  name: "reports",
  components: {
    DayReportFields,
    AgedDebtorField,
    BondingReportFields,
    SalesReportFields,
    RoomingReportFields,
    AffiliateReportFields,
    CustomerDetailReport,
    CustomerReportFields,
    RevenueReportFields,
    PaymentReportFields,
    AddWordRevenueReportFields,
    TourBookingAirlines,
    TourInstanceFlightBudgets,
  },
  data() {
    return {
      bonding: {},
      daybookreport: {},
      salesreport: {},
      errors: null,
      reportUnavailable: null,
      tours: {},
      suppliers : [],
      tour_managers: [],   
      airlines:[],
      affiliates: [],  
      reportVersion: 'v1', 
      reportTypes : [
        {
          name:'Rooming Report',
          slug:'rooming',
          component:'RoomingReportFields'
        },
        {
          name:'Day Report',
          slug:'day_report',
          component:'DayReportFields'
        },
        {
          name:'Aged Debtors Report',
          slug:'aged_debtor',
          component:'AgedDebtorField'
        },
        {
          name:'Bonding Reports',
          slug:'bonding',
          component:'BondingReportFields'
        },
        {
          name:'Sales Reports',
          slug:'sales',
          component:'SalesReportFields'
        },
        {
          name:'Booking Customer Detail Report',
          slug:'booking_customer_detail',
          component:'CustomerDetailReport'
        },
        {
          name:'Customer Report',
          slug:'customer_report',
          component:'CustomerReportFields'
        },
        {
          name:'Affiliate Report',
          slug:'affiliate',
          component:'AffiliateReportFields'
        },
        {
          name:'Revenue Report',
          slug:'revenue_report',
          component:'RevenueReportFields'
        },
        {
          name:'Payment Report',
          slug:'payment_report',
          component:'PaymentReportFields'
        },
        {
          name:'Addword Reveue Report',
          slug:'addword_revenue_report',
          component:'AddWordRevenueReportFields'
        },
        {
          name:'Airline Costing Report',
          slug:'airline_costing_report',
          component:'TourBookingAirlines'
        },
        {
          name:'Tour Instance Flight Budgets',
          slug:'tour_instance_flight_budgets',
          component:'TourInstanceFlightBudgets'
        },
      ],
      currentReportSlug:'rooming',
      currentReport: 'RoomingReportFields',
      showReportIndex: 'open',
    };
  },
  mounted(){
    this.getTours()
    this.getFieldsData()
  },
  methods:{
    getTours()
    {
      axios.get(this.$api + 'tours',
        {
        
        headers:{
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((response) => {
        this.tours = response.data.data
      });
    },
    getFieldsData()
    {
      axios.get(this.$api + 'reports/fields-data',
      {
        headers:{
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((response) => {
        if (response.data.status) {
          this.suppliers = response.data.data.suppliers
          this.affiliates = response.data.data.affiliates
          this.tour_managers = response.data.data.tour_managers
          this.airlines = response.data.data.airline

        }  
      });
    },
    selectReport(slug,comp) {
      this.currentReportSlug = slug
      this.currentReport = comp
    }
  }
};
</script>

<style>
ul.reports-outer {
  list-style: none;
  padding: 0px !important;

}

ul li.report-list {
  /* border: 1px solid black; */
  padding: 15px;
  text-align: left;
  background-color: #ebebeb;
  margin : 8px;
  cursor: pointer;
  box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19) !important;
  border-radius: 5px;
}

li.report-list.active {
    background-color: #ff8f0e !important;
    color: white;
}

.reports-div {
  min-height: 400px;
}
.align-items-right{
  text-align: right;
  padding: 15px;
}

label.form-label {
  font-size: 1rem;
  font-weight: 500;
}
</style>